import { BehaviorSubject } from 'rxjs'

export interface StickyElementRefs {
  sentinel?: HTMLElement;
  parentElement: HTMLElement;
  rect: DOMRect;
  observers?: IntersectionObserver[];
  placeholder?: HTMLElement;
}

const stickyElements = new BehaviorSubject<Map<HTMLElement, StickyElementRefs>>(new Map())

export const manageStickyElements = (context: Document | HTMLElement) => {
  const sticky = context instanceof HTMLElement && context.hasAttribute('sticky-element')
    ? [context]
    : Array.from(context.querySelectorAll<HTMLElement>('[sticky-element]'))
  const stickyMap: Map<HTMLElement, StickyElementRefs> = new Map()
  const document = context instanceof HTMLElement ? context.ownerDocument : context
  for (const el of sticky) {
    const sentinel = el.getAttribute('sentinel')
    if (sentinel) {
      const sentinelElement = document.querySelector<HTMLElement>(sentinel)
      const {parentElement} = el
      if (sentinelElement && parentElement?.localName !== 'template-like') {
        const rect = el.getBoundingClientRect()
        stickyMap.set(el, {
          sentinel: sentinelElement,
          rect,
          parentElement: el.parentElement!
        })
      }
    }
  }
  stickyElements.next(stickyMap)
}

const floatingHeaders = new BehaviorSubject<Map<HTMLElement, StickyElementRefs>>(new Map())

export const manageFloatingHeader = (el?: HTMLElement) => {
  const context = el ?? window.document
  const document = el ? el.ownerDocument : window.document
  const floatingHeadersEl = context instanceof HTMLElement && context.hasAttribute('floating-header')
    ? [context]
    : Array.from(context.querySelectorAll<HTMLElement>('[floating-header]'))
  const floatingMap: Map<HTMLElement, StickyElementRefs> = new Map()
  for (const elem of floatingHeadersEl) {
    const sentinelSelector = elem.getAttribute('sentinel')
    const sentinel = sentinelSelector
      ? (document.querySelector<HTMLElement>(sentinelSelector) ?? undefined)
      : undefined
    const rect = elem.getBoundingClientRect()
    floatingMap.set(elem, {
      sentinel,
      rect,
      parentElement: elem.parentElement!
    })
  }
  floatingHeaders.next(floatingMap)
}

export const stickyNotifiers = {
  floatingHeaders,
  stickyElements
}
